import { numberUtils } from '@zen/common-utils';

const { isZero } = numberUtils;

/**
 * Get a message body
 *
 * @param {Object} order
 * @param {string} order.underlyingAsset
 * @param {string} order.underlyingAmount
 * @param {string} order.pairAsset
 * @param {string} order.orderTotal
 * @param {string} order.makerPubKey
 * @param {string} order.requestedPayout
 * @param {string} order.providedAmount
 * @param {('buy'|'sell')} order.makeSide - buy or sell
 * @param {('buy'|'sell')} order.takeSide - buy or sell
 * @returns {string} the message body ready for the contract
 */
export default function getMessageBody({
  underlyingAsset,
  underlyingAmount,
  pairAsset,
  orderTotal,
  makerPubKey,
  requestedPayout,
  providedAmount,
  makeSide,
  takeSide,
} = {}) {
  return (
    `UnderlyingAsset: !!str ${underlyingAsset}\n` +
    `UnderlyingAmount: ${underlyingAmount}UL\n` +
    `PairAsset: !!str ${pairAsset}\n` +
    `OrderTotal: ${orderTotal}UL\n` +
    `MakerPubKey: !pk ${makerPubKey}\n` +
    (!isZero(requestedPayout) && !isZero(providedAmount)
      ? `RequestedPayout: ${requestedPayout}UL\n` + `ProvidedAmount: ${providedAmount}UL\n`
      : '') +
    (makeSide ? `makeSide: !!str ${makeSide}\n` : '') +
    (takeSide ? `takeSide: !!str ${takeSide}\n` : '')
  );
}
